<template>
  <div
    :key="message.id"
    class="block ignoreLinks clickable"
    :class="{ animateItem: animateIt, fadeOutDown: message.hide }"
  >
    <div class="colorBlue awaitingApproval" v-if="message.status == 12">
      Awaiting approval
    </div>
    <NoticeCombined
      v-if="message.type === 'NOTICE' || message.type === 'EVENT'"
      :message="message"
      :user_id="user_id"
      class="blockwrapper"
      :class="'category_' + message.category"
      @noticeEvent="noticeEvent"
    />
    <!-- <Notice
      v-if="message.type === 'notice'"
      :message="message"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    /> -->
    <!-- <NoticeImages
      v-else-if="message.type === 'noticeimages'"
      :message="message"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    /> -->
    <Info
      v-else-if="message.type === 'INFO'"
      :message="message"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    />
    <Dynamic
      v-else-if="message.type === 'DYNAMIC'"
      :message="message"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    />
    <Chat
      v-else-if="message.type === 'CHAT'"
      :message="message"
      :user_id="parseInt(user_id)"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    />
    <Event
      v-else-if="message.type === 'event'"
      :message="message"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    />
    <Article
      v-else-if="message.type === 'article'"
      class="blockwrapper"
      :class="'userType' + message.user_type"
      @noticeEvent="noticeEvent"
    />
    <Poll
      v-else-if="message.type === 'POLL'"
      :message="message"
      :user_id="user_id"
      class="blockwrapper"
      :class="'category_' + message.category"
      @noticeEvent="noticeEvent"
    />
    <Safeguarding
      :message="message"
      v-else-if="message.type === 'bg_journey'"
    />
  </div>
</template>
<script>
// import Article from "./noticeTypes/Article";
import Chat from "./noticeTypes/Chat";
import Dynamic from "./noticeTypes/Dynamic";
import Event from "./noticeTypes/Event";
import Info from "./noticeTypes/Info";
import NoticeImages from "./noticeTypes/NoticeImages";
import Notice from "./noticeTypes/Notice";
import NoticeCombined from "./noticeTypes/NoticeCombined";
import Poll from "./noticeTypes/Poll";
import ApiService from "@/services/ApiService";
import Safeguarding from "./noticeTypes/Safeguarding";

export default {
  name: "notice-main",
  components: {
    // Article,
    Chat,
    Dynamic,
    Event,
    Info,
    // NoticeImages,
    // Notice,
    Poll,
    Safeguarding,
    NoticeCombined,
  },
  props: { message: Object, user_id: Number },
  data() {
    return {
      animateIt: false,
      liked: false,
      // results: [{ type: "notice" }]
    };
  },
  methods: {
    // redirect() {},
    noticeEvent(options) {
      if (options.action === "showNotice") {
        this.$emit("noticeEvent", options);
      } else if (options.action === "showChat") {
        options.id = this.message.user_id;
        this.$emit("noticeEvent", options);
      } else if (options.action === "noticeLike") {
        this.likeNotice(options);
      } else if (options.action === "hideNotice") {
        this.hideNotice(options);
      } else if (options.action === "deleteNotice") {
        this.$confirm(
          "Remove this post from the School Notice Board?",
          "Warning",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "warning",
          }
        ).then(() => {
          this.$message({
            type: "success",
            message: "Delete completed",
          });
          this.hideNotice(options);
        });
      }
    },
    likeNotice(options) {
      ApiService.generalApi.noticeLike(options.id).then(() => {
        if (this.liked === true) {
          return;
        }
        this.message.total_likes = parseInt(this.message.total_likes) || 0;
        this.message.total_likes += 1;
        this.liked = true;
      });
    },
    hideNotice(options) {
      ApiService.generalApi.hideNotification(options.id);
      this.$emit("noticeEvent", options);
    },
  },
};
</script>
